import { Component, Input, TrackByFunction } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import {
  TICKET_COMMON_INFORMATION,
  TICKET_TABLE_HEADER,
} from './ticket-transaction-table.config';
import { TicketTableHeader } from './ticket-transaction-table.types';
import { UtilsService } from '../../../../core/services/utils.service';
import { JabbaTax, Payment, Tax, TicketAdInfo, TicketItem } from '../../../../core/models/ticket.model';
import { TicketMeasureUnitsPipe } from './pipes/ticket-measure-units.pipe';
import { PaymentTypePipe } from './pipes/payment-type.pipe';
import { TaxPercentagePipe } from './pipes/tax-percentage.pipe';
import { TicketData } from '../../../../core/modules/tickets/ticket.types';

@Component({
  selector: 'tax-ticket-transaction-table',
  templateUrl: './ticket-transaction-table.component.html',
  styleUrls: ['./ticket-transaction-table.component.sass'],
  standalone: true,
  imports: [SharedModule, TicketMeasureUnitsPipe, TicketMeasureUnitsPipe, PaymentTypePipe, TaxPercentagePipe],
})
export class TicketTransactionTableComponent {
  @Input() ticketModel: TicketData | null = null;
  readonly ticketTableHeaderData = TICKET_TABLE_HEADER;
  readonly ticketCommonInformation = TICKET_COMMON_INFORMATION;

  readonly trackByTicketTransactionTableHeader: TrackByFunction<TicketTableHeader> = this.utilsService.trackByIndex;
  readonly trackByItemIndex: TrackByFunction<TicketItem> = this.utilsService.trackByIndex;
  readonly trackByJabbaTaxIndex: TrackByFunction<JabbaTax> = this.utilsService.trackByIndex;
  readonly trackByTaxIndex: TrackByFunction<Tax> = this.utilsService.trackByIndex;
  readonly trackByPaymentIndex: TrackByFunction<Payment> = this.utilsService.trackByIndex;
  readonly trackByTicketAdInfoIndex: TrackByFunction<TicketAdInfo> = this.utilsService.trackByIndex;
  constructor(private utilsService: UtilsService) {}
}
